var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0752 9.97508C11.4918 8.57508 10.3835 7.52508 9.04182 7.00008C9.80016 6.41675 10.2668 5.48341 10.2668 4.49175C10.2668 2.62508 8.80849 1.16675 7.00016 1.16675C5.19182 1.16675 3.73349 2.62508 3.73349 4.43341C3.73349 5.42508 4.20016 6.35841 4.95849 6.94175C3.61682 7.46675 2.50849 8.51675 1.92516 9.91675C1.69182 10.5001 1.75016 11.2001 2.10016 11.7251C2.45016 12.3084 3.09182 12.6001 3.79182 12.6001H10.2668C10.9668 12.6001 11.5502 12.2501 11.9585 11.7251C12.3085 11.2001 12.3668 10.5584 12.0752 9.97508Z","fill":"white"}));
}

User.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = User;

User.default = User;
